import { HostAction, HostActionEnum, HostState } from './types';

const initialState: HostState = {
  isLoading: {
    get: false
  },
  result: {}
};

const host = (state = initialState, action: HostAction): HostState => {
  switch (action.type) {
    case HostActionEnum.REQUEST_HOST:
      return {
        ...state,
        isLoading: { ...state.isLoading, get: true },
        result: {}
      };

    case HostActionEnum.RESULT_HOST:
      return {
        ...state,
        isLoading: { ...state.isLoading, get: false },
        result: { ...state.result, get: action.status },
        host: action.data
      };

    default:
      return state;
  }
};
export default host;
